import {
  LOAD_HEADER,
  LOAD_HEADER_COMPLETE,
  SET_QUERY_STRING
} from '../constants/actionTypes';

export const initialState = {
  menuBurguer: [],
  loaded: false,
  searchQuery: ''
};

export default (state = initialState, action) => {
  const { type, menuBurguer, searchQuery } = action;
  switch (type) {
    case LOAD_HEADER:
      return { ...state, loaded: true };
    case LOAD_HEADER_COMPLETE:
      return {
        ...state,
        menuBurguer,
        loaded: false
      };
    case SET_QUERY_STRING:
      return {
        ...state,
        searchQuery
      };
    default:
      return state;
  }
};
